/**
 * @file auth-client.js
 * @description This contain all auth related client side actions
 * @version 0.0.1
 * Created at: 13/08/2025
 * Updated at: 13/08/2025
 */
import { customSessionClient, emailOTPClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  /** The base URL of the server (optional if you're using the same domain) */
  // baseURL: 'http://localhost:3000',
  plugins: [emailOTPClient(), [customSessionClient()]],
});
